import { useQuery } from "@tanstack/react-query";
import httpInjectorService from "services/http-injector.service";

export const useSpace = (spaceId) => {
  const numericId = Number(spaceId);

  return useQuery({
    queryKey: ["space", numericId],
    queryFn: async ({ queryKey }) => {
      const [, id] = queryKey;
      if (!id) return null;

      const response = await httpInjectorService.getSpaceDetails({ space_id: id });
      return response?.data ?? null;
    },
    enabled: !!numericId,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
